import React from 'react';

import * as ResourceApi from 'api/resources';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import AutoManagedAccordion from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactory,createButtonSectionFactoryWithAdditionalArgs} from "hoc/CreateButtonSection";

export default {
  name: "review",
  subSection: true,
  resource: true,
  hideIfResourceIsNoU: true,

  fields: [
    {
        type: 'hardcodedText',
        props: {
          heading: 'Product Selector Screen (aka Welcome Screen)',
        }
    },

    {
        type: 'contenteditable',
        name: 'productSelectorTitle',
        required: false,
        props: {
            label: 'Title copy',
            helperText: "Have you tried any of these products?",
        }
    },
    {
        type: 'contenteditable',
        name: 'productSelectorDescription',
        required: false,
        showField: true,
        props: {
          label: 'Upper copy',
          helperText: "This copy block appears above the product listing.",
        }
    },
    {
        type: 'contenteditable',
        name: 'productSelectorFooter',
        required: false,
        props: {
            label: 'Lower copy',
            helperText: "This copy block appears below the product listing.",
        }
    },

    {
        type: 'yesnoradio',
        name: 'enableReminders',
        required: true,
        props: {
          labelKey: 'editbreak.steps.review.reminder.enable',
        //   helperText: "Enabling this will add a few fields/sections below",
        }
    },

    {
        type: 'contenteditable',
        name: 'notFamiliarCopy',
        required: false,
        showField: (proxy) => {
            return proxy.currentResource.enableReminders
        },
        props: {
            label: 'Product Selector - skip link copy',
            helperText: "e.g. I'm not familiar with any of these products.",
        }
    },

    // -----------------------------------------------------------------
    {
        type: 'hardcodedText',
        props: {
          heading: 'Product Review Screen',
        }
    },

    {
        type: 'contenteditable',
        name: 'productReviewTitle',
        required: false,
        props: {
            label: 'Title copy',
            helperText: "Submit your review",
        }
    },

    // -----------------------------------------------------------------

    {
        type: 'hardcodedText',
        props: {
          heading: 'Product Review Thank-you Screen',
        }
    },

    {
        type: 'contenteditable',
        name: 'reviewThankyouTitle',
        required: false,
        props: {
            label: 'Thank you - Title copy',
            // helperText: <React.Fragment>e.g. <i dangerouslySetInnerHTML={{__html: 'Thanks for submitting your review'}} /></React.Fragment>
            helperText: 'e.g. Thanks for submitting your review'
        }
    },

    {
        type: 'contenteditable',
        name: 'reviewThankyouDescription',
        required: false,
        props: {
            label: 'Thank you - Upper copy',
            helperText: "This copy block appears above the thank you image.",
        }
    },

    {
        name: 'thankyouImageId',
        idFor: 'thankyouImage',
        type: 'image',
        required: false,
        props: {
          label: 'Thank you - Body Image',
          imageType: 'personalityResult'
        }
    },


    {
        type: 'contenteditable',
        name: 'reviewThankyouFooter',
        required: false,
        props: {
            label: 'Thank you - Lower copy',
            helperText: "This copy block appears below the thank you image.",
        }
    },

    // -----------------------------------------------------------------

    {
        subSection: true,
        key: "reminder",
        sectionWrapper: AutoManagedAccordion,
        props: {
          'headerKey': 'editbreak.steps.review.reminder.heading',
          showField: (proxy) => {
            return proxy.currentResource.enableReminders
        },
        },
        fields: [

        {
            conditionalSection: true,
            name: 'enableReminders',
            required: true,
            props: {
                labelKey: 'editbreak.steps.review.reminder.enable',
            //   showFild: true,

            },
            fields: [

                // -----------------------------------------------------------------
                {
                    type: 'hardcodedText',
                    props: {
                      heading: 'Reminder Sign-up Screen',
                    }
                },

                {
                    type: 'contenteditable',
                    name: 'reminderIntroTitle',
                    required: false,
                    props: {
                        label: 'Title copy',
                        // helperText: "e.g. <i>Thanks for submitting your review</a>",
                        helperText: 'e.g. Would you like to submit a review later?'
                    }
                },

                {
                    type: 'contenteditable',
                    name: 'reminderIntroDescription',
                    required: false,
                    props: {
                        label: 'Upper copy',
                        helperText: "This copy block appears above the product selector",
                    }
                },

                // -----------------------------------------------------------------

                {
                    type: 'hardcodedText',
                    props: {
                      heading: 'Reminder Thank you Screen',
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'reminderThankyouHeader',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.review.fields.reminderThankyouHeader',
                        helperText: "e.g. We'll email you soon!",
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'reminderThankyouIntro',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.review.fields.reminderThankyouIntro',
                        helperText: "e.g. Stay tuned in your inbox soon for a reminder to submit your product review.",
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'reminderThankyouBody',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.review.fields.reminderThankyouBody',
                        helperText: "Want to get a head start on your product review?",
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'reminderThankyouBodyButton',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.review.fields.reminderThankyouBodyButton',
                        helperText: "e.g. Add to Cart - Leave this blank and no button will appear. ",
                    }
                },
                {
                    type: 'text',
                    name: 'reminderThankyouBodyButtonUrl',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.review.fields.reminderThankyouBodyButtonUrl',
                        helperText: "https://www.google.com",
                    }
                },
                // ----------------------------------------------------------------

                {
                    type: 'hardcodedText',
                    props: {
                    heading: 'Reminder Email Link',
                    }
                },

                {
                    type: 'text',
                    name: 'reminderEmailButtonUrl',
                    required: false,
                    showField: (proxy) => {
                        return proxy.currentResource.enableReminders
                    },
                    props: {
                        labelKey: 'editbreak.steps.review.product.reminder.break_url',
                        helperText: "URL of second Break with only a review step. All follow-up emails link back to the same break",
                    }
                },

            ]
          }
        ]
    }, // reminder settings

    // -----------------------------------------------------------------
    // Products

    {
        name: 'products',
        subSection: true,
        resource: true,
        collection: true,
        sectionWrapper: IndexedSubSectionWrapper,
        deletable: true,
        canDelete: (formProxy) => {
        //   var parentReview = formProxy.parentCurrentResource;
        //   return parentReview.products && parentReview.products.length > 1;
            return true
        },

        sortable: true,
        sortableName: "reviewProductsOrder",
        toggleSortLabelKey: 'editbreak.steps.review.product.reorder_toggle',
        resourceType: ResourceApi.Types.Product,

        props: {
          headerKey: 'editbreak.steps.review.product',
          getCustomSectionHeader: (product, sectionIndex) => {
            return product.dropdownTitle
            && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
          }
        },

        footerContent: createButtonSectionFactory(ResourceApi.Types.Product),

        fields: [
            {
                type: 'contenteditable',
                name: 'title',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.review.product.title',
                //   placeholderKey: 'editbreak.steps.personality_quiz.result.title.placeholder',
                //   helpContent: <PersonalityQuizResultTitleToolTip/>,
                //   helpHeader: 'editbreak.steps.personality_quiz.result.title'
                }
            },
            {
                type: 'text',
                name: 'dropdownTitle',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.review.product.dropdown_title',
                  helperText: "Sorry, dropdown menus can't contain html"
                //   placeholderKey: 'editbreak.steps.personality_quiz.result.title.placeholder',
                //   helpContent: <PersonalityQuizResultTitleToolTip/>,
                //   helpHeader: 'editbreak.steps.personality_quiz.result.title'
                }
            },
            {
                type: 'contenteditable',
                name: 'description',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.review.product.description',
                //   placeholderKey: 'editbreak.steps.personality_quiz.result.title.placeholder',
                //   helpContent: <PersonalityQuizResultTitleToolTip/>,
                //   helpHeader: 'editbreak.steps.personality_quiz.result.title'
                }
            },

            {
                name: 'imageId',
                idFor: 'image',
                type: 'image',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.review.product.image',
                  imageType: 'referral3x2'
                }
            },
            {
                type: 'hardcodedText',
                props: {
                  heading: 'BazaarVoice Config',
                }
            },
            {
                type: 'text',
                name: 'productId',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.review.product.bv_id',
                }
            },
            {
                type: 'text',
                name: 'apiKey',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.review.product.bv_api_key',
                }
            },
            {
                type: 'text',
                name: 'encodingKey',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.review.product.bv_encoding_key',
                }
            },

            {
                type: 'hardcodedText',
                props: {
                  heading: 'Reminder Confirmation Email',
                  showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                }
            },
            {
                type: 'text',
                name: 'confirmationEmailHeader',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_header',
                }
            },
            {
                type: 'textarea',
                name: 'confirmationEmailBody',
                required: false,
                showField: (proxy) => {
                    // console.log(proxy.currentBaseResource) // break
                    // console.log(proxy.currentResource) // product
                    // console.log(proxy.parentCurrentResource)
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_body',
                    helperText: "Appears below image, above button",

                }
            },
            {
                type: 'text',
                name: 'confirmationEmailButtonCopy',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.button_copy',
                    helperText: "e.g. Add to Cart",
                }
            },
            {
                type: 'text',
                name: 'confirmationEmailButtonUrl',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.button_url',
                    helperText: "https://www.google.com",
                }
            },
            {
                type: 'textarea',
                name: 'confirmationEmailFooter',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_footer',
                    // helperText: "e.g. Add to Cart",
                }
            },
            // ----------------------------------------------------------------
            {
                type: 'hardcodedText',
                props: {
                  heading: 'Reminder Follow-up Email',
                }
            },
            {
                type: 'text',
                name: 'reminderEmailHeader',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_header',
                    // helperText: "e.g. Add to Cart",
                }
            },

            {
                type: 'textarea',
                name: 'reminderEmailBody',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_body',
                    // helperText: "e.g. Add to Cart",
                }
            },

            {
                type: 'text',
                name: 'reminderEmailButtonCopy',
                required: true,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.button_copy',
                    helperText: "e.g. Submit your review. ",
                }
            },

            {
                type: 'textarea',
                name: 'reminderEmailFooter',
                required: false,
                showField: (proxy) => {
                    return proxy.parentCurrentResource.enableReminders
                },
                props: {
                    labelKey: 'editbreak.steps.review.product.reminder.confirmation_footer',
                    // helperText: "e.g. Add to Cart",
                }
            },

            {
                name: 'sampleReviews',
                subSection: true,
                resource: true,
                collection: true,
                sectionWrapper: IndexedSubSectionWrapper,
                deletable: true,
                canDelete: (formProxy) => {
                //   var parentReview = formProxy.parentCurrentResource;
                //   return parentReview.products && parentReview.products.length > 0;
                    return true;
                },

                sortable: true,
                sortableName: "productSampleReviewsOrder",
                toggleSortLabelKey: 'editbreak.steps.review.sample_review.reorder_toggle',
                resourceType: ResourceApi.Types.SampleReview,

                props: {
                  headerKey: 'editbreak.steps.review.sample_review.header',
                  getCustomSectionHeader: (sampleReview, sectionIndex) => {
                    return `Sample Review ${(sectionIndex + 1)}`
                  }
                },

                footerContent: createButtonSectionFactory(ResourceApi.Types.SampleReview),

                fields: [
                    {
                        type: 'text',
                        name: 'title',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.review.sample_review.title',
                        }
                      },
                    {
                        type: 'contenteditable',
                        name: 'detail',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.review.sample_review.detail',
                        //   placeholderKey: 'editbreak.steps.personality_quiz.result.title.placeholder',
                        //   helpContent: <PersonalityQuizResultTitleToolTip/>,
                        //   helpHeader: 'editbreak.steps.personality_quiz.result.title'
                        }
                    },
                    {
                        type: 'number',
                        name: 'rating',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.review.sample_review.rating',
                          min: 1,
                          max: 5,
                        //   helpContent: <ChecklistMinItemsToolTip/>,
                        //   helpHeader:  <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.checklist.result.min_checked'}/></IntlProvider>
                        }
                      },
                      {
                        type: 'text',
                        name: 'nickname',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.review.sample_review.nickname',
                        }
                      },

                ]
            },

        ]

    },




    // {
    //     name: 'reminder',
    //     subSection: false,
    //     resource: true,
    //     collection: false,
    //     sectionWrapper: IndexedSubSectionWrapper,
    //     deletable: false,

    //     sortable: false,

    //     props: {
    //       headerKey: 'editbreak.steps.review.reminder.heading',
    //       getCustomSectionHeader: (foo, sectionIndex) => {
    //           console.log(foo)
    //         return `Reminder Settings`
    //       }
    //     },

    //     fields: [
    //         {
    //             type: 'yesnoradio',
    //             name: 'enableReminders',
    //             required: true,
    //             showField: (proxy) => {
    //                 console.log("bar")
    //                 console.log(proxy.currentResource)
    //                 return true
    //             },
    //             props: {
    //               labelKey: 'editbreak.steps.review.reminder.enable'
    //             }
    //         },

    //         {
    //             conditionalSection: true,
    //             name: "enableReminders",
    //             required: true,
    //             props: {
    //                 labelKey: 'editbreak.steps.review.reminder.enable'
    //             },

    //             fields: [
    //                 {
    //                     type: 'contenteditable',
    //                     name: 'reminderTitle',
    //                     required: false,
    //                     showField: true,
    //                     props: {
    //                       labelKey: 'editbreak.steps.review.fields.title',
    //                     }
    //                   },

    //             ]
    //         },


    //     ]
    // }
    {
        type: 'currentId',
        label: 'Review ID',
    },
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/review.js